import { Pipe, PipeTransform } from '@angular/core';
import { stripHttpWWWFromUrl } from '../../core/pure-utils/string-utils';

/**
 * Removes the the http protocol and 'www' from a url string.
 */
@Pipe({
    name: 'stripUrl',
    standalone: false
})
export class StripUrlPipe implements PipeTransform {
  transform(value: string): string {
    return stripHttpWWWFromUrl(value);
  }
}
